import type { createBrowserRouter, RouteObject } from 'react-router-dom';
import TsdbLayout from './TsdbLayout';
import { copiedPage, isTsdbPath, TSDB_PAGES, TSDB_ROUTE_PREFIX, type TsdbPage } from './tsdbPaths';

/** /dashboard/tsdb/<page> routes rendering the original page components. */
export const tsdbRoute = (pages: Record<TsdbPage, JSX.Element>): RouteObject => ({
  path: 'tsdb',
  element: <TsdbLayout />,
  children: TSDB_PAGES.map((page) => ({ path: page, element: pages[page] })),
});

/** Pages navigate to hard-coded /dashboard/<page> paths; keep a TSDB session on the copies. */
export const keepTsdbNavigation = (router: ReturnType<typeof createBrowserRouter>): void => {
  let previous = router.state.location.pathname;
  router.subscribe((state) => {
    const { pathname, search, hash } = state.location;
    if (pathname === previous) return;
    const from = previous;
    previous = pathname;
    const page = copiedPage(pathname);
    if (isTsdbPath(from) && page) {
      router.navigate(`${TSDB_ROUTE_PREFIX}/${page}${search}${hash}`, { replace: true });
    }
  });
};
